import React, { useState, useEffect } from "react";
import s from "./Comprobantes.module.css";

//assets
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import reportService from "../../../api/reports/reportsServices";
import { dateFormats } from "../../../helpers/convertDate";

//Custom Components
import FiltrosComprobantes from "./Filters";
import Pager from "../../Shared/Pagination/Pagination";
import { Currency } from "../../../helpers/currencyConvert";
import { tablaComprobantes } from "./Helper/tableHelpers";

//Material Ui
import {
  Grid,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Snackbar,
  Alert,
  Button,
} from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LocalPrintshopRoundedIcon from "@mui/icons-material/LocalPrintshopRounded";
import DescriptionIcon from "@mui/icons-material/Description";
import printTable from "../../../helpers/imprimir";
import exportToExcel from "../../../helpers/exportExcel";
import { formatJavaCompletossx } from "../../../config/strings";
import { currencyFormat } from "../../../helpers/currency";

export const Comprobantes = () => {
  const dates = dateFormats();

  const { formatLocalDate } = dateFormats();
  const { formatCurrency } = currencyFormat();
  const { t } = useTranslation();
  const { textColor } = useSelector((state) => state.local);
  const { currentLogo } = useSelector((state) => state.local);
  const [logo, setLogo] = useState("");
  const [printing, setPrinting] = useState(false);
  const [completeReport, setCompleteReport] = useState([]);
  const [games, setGames] = useState([]);
  const [loadingFilters, setLoadingFilters] = useState(false);
  const [loadingReport, setLoadingReport] = useState(false);
  const [filters, setFilters] = useState({
    gameType: 0,
    gameId: 0,
    dateType: 0,
    agencyNumberFrom: 0,
    agencyNumberTo: 0,
    date: null,
  });
  const [newFilters, setNewFilters] = useState({
    gameType: 0,
    gameId: 0,
    dateType: 0,
    agencyNumberFrom: 0,
    agencyNumberTo: 0,
    date: null,
  });

  //Paginado
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [searching, setSearching] = useState(0);
  const [openError, setOpenError] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);

  //Filtros
  const [dateType, setDateType] = useState(0);
  const [sort, setSort] = useState({
    criteria: "DESC",
    field: "agencyNumber",
  });

  const handleExport = () => {
    //let game = items[0].game.name;
    let excelData = [];
    const itemExcel1 = {};
    let today = new Date();
    excelData.push(itemExcel1);
    completeReport.map((item) => {
      console.log("mapping", items);
      const itemExcel = {};
      itemExcel[t("agency")] = item?.agencyNumber || "-";
      itemExcel[t("operationDate")] =
        formatLocalDate(item?.operationDate, formatJavaCompletossx) || "-";
      itemExcel[`${t("drawNumber")}/${t("serie")}`] =
        item?.serie || item?.raffleNumber || "-";
      itemExcel[t("voucher")] = `${item?.nroOutput || 0}`;
      itemExcel[t("type")] = item?.deliveryNoteType || "-";
      itemExcel[t("couponFrom")] = item?.nroCouponFrom || "-";
      itemExcel[t("couponUp")] = item?.nroCouponTo || "-";
      itemExcel[t("quantity")] = item?.nroCouponTo - item?.nroCouponFrom || "-";
      itemExcel[t("amount")] = `${formatCurrency(item?.price) || "-"}`;
      excelData.push(itemExcel);
    });
    const typeName =
      filters.gameType === 0
        ? t("all")
        : filters.gameType === 1
          ? t("preprinted")
          : t("instant");
    exportToExcel(
      excelData,
      `${t("consultVouchers")} ${typeName} - ${formatLocalDate(today.toISOString(), formatJavaCompletossx)}`,
    );
  };

  const handleSort = (item) => {
    setSort((prev) => ({
      criteria:
        prev.field === item
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: item,
    }));
  };

  const handleSearch = () => {
    setNewFilters(filters);
    setPage(1);
    setSearching((prev) => prev + 1);
  };

  const handleCleanFilters = () => {
    setFilters({
      gameType: 0,
      gameId: 0,
      dateType: 0,
      agencyNumberFrom: 0,
      agencyNumberTo: 0,
      date: null,
    });
    setNewFilters({
      gameType: 0,
      gameId: 0,
      dateType: 0,
      agencyNumberFrom: 0,
      agencyNumberTo: 0,
      date: null,
    });
    setItems([]);
    setPage(1);
    setTotalPages(1);
    setTotalResults(0);
    setSearching(0);
  };

  useEffect(() => {
    if (newFilters.gameType !== 0) {
      setLoading(true);
      reportService
        .getReceipts(page, pageSize, sort, { ...newFilters, dateType })
        .then((res) => {
          setItems(res.content);
          setTotalPages(res.totalPages);
          setTotalResults(res.totalElements);
          setOpenError(false);
          setLoading(false);
        })
        .catch((e) => {
          setItems([]);
          setOpenError(true);
          setLoading(false);
        });
    }
  }, [page, pageSize, searching, sort]);

  useEffect(() => {
    if (newFilters.gameType !== 0) {
      setLoadingReport(true);
      reportService
        .getAllReceipts(sort, { ...newFilters, dateType })
        .then((res) => {
          setCompleteReport(res);
          setLoadingReport(false);
        })
        .catch((e) => {
          setOpenError(true);
          setLoadingReport(false);
        });
    }
  }, [searching, sort]);

  useEffect(() => {
    setLogo(currentLogo?.imgBase64);
  }, [currentLogo]);

  useEffect(() => {
    if (printing === true) {
      printTable(document.getElementById("receipts-table"));
      setPrinting(false);
    }
  }, [printing]);

  return (
    <Grid container className={s.container}>
      <Grid item xs={12} className={s.header}>
        <Grid item container xs={12} className={s.titleContainer}>
          <Grid
            item
            xs={11}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <ReceiptIcon
              sx={{ fontSize: "2rem", color: "primary.main", mr: 2 }}
            />
            <h4>{t("consultVouchers")}</h4>
          </Grid>
        </Grid>
      </Grid>

      {loadingFilters ? (
        <Grid
          item
          xs={11}
          sx={{ display: "flex", alignItems: "center", height: "50px" }}
        >
          <CircularProgress color="primary" />
          <p style={{ margin: 0, marginLeft: "10px" }}>{t("loadingFilter")}</p>
        </Grid>
      ) : (
        <>
          <FiltrosComprobantes
            searching={searching}
            handleSearch={handleSearch}
            handleCleanFilters={handleCleanFilters}
            dateType={dateType}
            setDateType={setDateType}
            filters={filters}
            setFilters={setFilters}
            setLoadingFilters={setLoadingFilters}
            games={games}
            setGames={setGames}
            setSort={setSort}
          />
          <Grid item xs={11} className={s.options}>
            <Grid item xs={6}>
              {loading ? (
                <CircularProgress size="1.2rem" />
              ) : (
                <p
                  style={{ fontSize: "1.2rem", margin: 0 }}
                >{`${t("results")}: ${totalResults}`}</p>
              )}
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                size="small"
                onClick={() => setPrinting(true)}
                variant="contained"
                sx={{ ml: 1 }}
                disabled={!items?.length}
              >
                <LocalPrintshopRoundedIcon
                  color={textColor}
                  sx={{ fontSize: "30px" }}
                />
                <p>{t("print")}</p>
              </Button>
              <Button
                size="small"
                onClick={() => handleExport()}
                variant="contained"
                disabled={!items?.length}
                sx={{ ml: 1 }}
              >
                <DescriptionIcon color={textColor} sx={{ fontSize: "30px" }} />
                <p>Excel</p>
              </Button>
            </Grid>
          </Grid>
        </>
      )}

      {!filters.gameType ? (
        <Grid item xs={12} className={s.loader} key={3}>
          <p>{t("selectGameType")}</p>
        </Grid>
      ) : loading ? (
        <Grid item xs={12} className={s.loader} key={1}>
          <CircularProgress size={"4rem"} />
        </Grid>
      ) : items?.length ? (
        <Grid item container xs={11} className={s.data} id="receipts-table">
          {printing !== true ? null : (
            <div className="logo">
              <img src={logo} alt="logo" />
            </div>
          )}
          <TableContainer className={s.tableContainer}>
            <Table className="print-table" stickyHeader>
              <TableHead>
                <TableRow>
                  <Tooltip title={t("sort")} placement="top">
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSort("agencyNumber")}
                    >
                      {`${t("agency")} ${sort.field === "agencyNumber" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                  </Tooltip>
                  <Tooltip title={t("sort")} placement="top">
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSort("operationDate")}
                    >
                      {`${t("operationDate")} ${sort.field === "operationDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                  </Tooltip>
                  <Tooltip title={t("sort")} placement="top">
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSort("raffleNumber")}
                    >
                      {`${t("drawNumber")} ${sort.field === "raffleNumber" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                  </Tooltip>
                  <Tooltip title={t("sort")} placement="top">
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSort("nroNote")}
                    >
                      {`${t("voucher")} ${sort.field === "nroNote" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                  </Tooltip>
                  <Tooltip title={t("sort")} placement="top">
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSort("type")}
                    >
                      {`${t("type")} ${sort.field === "type" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                  </Tooltip>
                  <Tooltip title={t("sort")} placement="top">
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSort("nroCouponFrom")}
                    >
                      {`${t("coupon")} ${t("from")} ${sort.field === "nroCouponFrom" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                  </Tooltip>
                  <Tooltip title={t("sort")} placement="top">
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSort("nroCouponTo")}
                    >
                      {`${t("coupon")} ${t("to")} ${sort.field === "nroCouponTo" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                  </Tooltip>
                  <Tooltip title={t("sort")} placement="top">
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSort("couponQty")}
                    >
                      {`${t("quantity")} ${sort.field === "couponQty" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                  </Tooltip>
                  <Tooltip title={t("sort")} placement="top">
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        cursor: "pointer",
                      }}
                      onClick={() => handleSort("price")}
                    >
                      {`${t("amount")} ${sort.field === "price" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                  </Tooltip>
                </TableRow>
              </TableHead>
              <TableBody>
                {printing !== true
                  ? items.map((item, i) => tablaComprobantes(item, t, dates, i))
                  : completeReport.map((item, i) =>
                      tablaComprobantes(item, t, dates, i),
                    )}

                {loadingReport ? (
                  <Grid
                    item
                    xs={11}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      height: "5px",
                    }}
                  >
                    <CircularProgress color="primary" />
                    <p style={{ margin: 0, marginLeft: "10px" }}>
                      {t("loadingFilter")}
                    </p>
                  </Grid>
                ) : (
                  <>
                    <TableRow className="oneline">
                      <TableCell colSpan={2} sx={{ fontWeight: 600 }}>
                        {t("delivery")}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        {t("quantity")}
                      </TableCell>
                      <TableCell colSpan={2}>{completeReport.length}</TableCell>
                      <TableCell colSpan={3} sx={{ fontWeight: 600 }}>
                        {t("amount")}
                      </TableCell>
                      <TableCell>
                        <Currency
                          value={completeReport.reduce(
                            (acc, b) => acc + b.price * b.couponQty,
                            0,
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow className="oneline">
                      <TableCell colSpan={2} sx={{ fontWeight: 600 }}>
                        {t("return")}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        {t("quantity")}
                      </TableCell>
                      <TableCell colSpan={2}>
                        {
                          completeReport.filter(
                            (item) => item?.type !== "Salida",
                          ).length
                        }
                      </TableCell>
                      <TableCell colSpan={3} sx={{ fontWeight: 600 }}>
                        {t("amount")}
                      </TableCell>
                      <TableCell>
                        <Currency
                          value={completeReport
                            .filter((item) => item?.type !== "Salida")
                            ?.reduce(
                              (acc, b) => acc + b.price * b.couponQty,
                              0,
                            )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow className="oneline">
                      <TableCell colSpan={2} sx={{ fontWeight: 600 }}>
                        {t("sales")}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        {t("quantity")}
                      </TableCell>
                      <TableCell colSpan={2}>
                        {completeReport.length -
                          completeReport.filter(
                            (item) => item?.type !== "Salida",
                          ).length}
                      </TableCell>
                      <TableCell colSpan={3} sx={{ fontWeight: 600 }}>
                        {t("amount")}
                      </TableCell>
                      <TableCell>
                        <Currency
                          value={
                            completeReport.reduce(
                              (acc, b) => acc + b.price * b.couponQty,
                              0,
                            ) -
                            completeReport
                              .filter((item) => item?.type !== "Salida")
                              ?.reduce(
                                (acc, b) => acc + b.price * b.couponQty,
                                0,
                              )
                          }
                        />
                      </TableCell>
                    </TableRow>
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      ) : (
        <Grid item xs={12} className={s.loader} key={2}>
          <p>{t("noResults")}</p>
        </Grid>
      )}
      <Grid
        item
        container
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          aligntItems: "center",
          mb: 10,
        }}
      >
        <Pager
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageCustom={pageCustom}
          setPageCustom={setPageCustom}
        />
      </Grid>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
    </Grid>
  );
};
